import ActionWarehouseTypes from "./warehouse.types";

export const addWarehosuer = (payload: any) => ({
  type: ActionWarehouseTypes.ADD_WAREHOUSE,
  payload,
});

export const deleteWarehouse = (payload: any) => ({
  type: ActionWarehouseTypes.DELETE_WAREHOUSE,
  payload,
});

export const editWarehouse = (payload: any) => ({
  type: ActionWarehouseTypes.EDIT_WAREHOUSE,
  payload,
});

export const getWarehosuerList = (payload: any) => ({
  type: ActionWarehouseTypes.GET_WAREHOUSLIST,
  payload,
});
